export default class CQRSCommand {
    get id() { return this._ticketId; }
    get params() { return this._params; }
    set params(value) { this._params = value; }
    get command() { return this._command; }
    set command(value) { this._command = value; }
    constructor(_command, _params, _isBlob, _url, _api, _callPeriod = 1000, _ticketCheckEndpoint = "/cqrs", _updateCallback = undefined) {
        this._callPeriod = 1000;
        this._ticketId = null;
        this.isBlob = false;
        this.ticketCheckEndpoint = "/cqrs";
        this.api = _api;
        this._command = _command;
        this._params = _params;
        this.url = _url;
        this._callPeriod = _callPeriod;
        this.isBlob = _isBlob;
        this.ticketCheckEndpoint = _ticketCheckEndpoint;
        this.updateCallback = _updateCallback;
        this.makeRequest = this.makeRequest.bind(this);
        this.getResult = this.getResult.bind(this);
    }
    static fromJSON(json, _api) {
        return new CQRSCommand(json.command, json.params, !!json.isBlob, json.url, _api);
    }
    static fromJSONString(json, _api) {
        return CQRSCommand.fromJSON(JSON.parse(json), _api);
    }
    getResult() {
        let me = this;
        let cqrsQuery = {
            method: "POST",
            body: JSON.stringify({
                ticketId: me._ticketId
            })
        };
        let method = me.api.asyncFetch;
        method(me.ticketCheckEndpoint, cqrsQuery).then((_e) => {
            console.log(_e);
            if (_e.status === "выполнено") {
                me.madeResolve && me.madeResolve(_e.result);
            }
            else {
                setTimeout(() => {
                    if (me.updateCallback) {
                        me.updateCallback(_e.status);
                    }
                    me.getResult();
                }, me._callPeriod);
            }
        });
    }
    makeRequest() {
        let me = this;
        return new Promise((resolve, reject) => {
            me.api.asyncFetchWithoutQueing(me.url, {
                method: "POST",
                body: JSON.stringify({
                    command: me.command,
                    params: me.params
                })
            }).then((e) => {
                me._ticketId = e.ticket.id;
                me.madeResolve = resolve;
                me.madeReject = reject;
                me.getResult();
            }, (err) => {
                reject(err);
            });
        });
    }
}
